import { render } from "./SortableTableHeading.vue?vue&type=template&id=269987da&scoped=true"
import script from "./SortableTableHeading.vue?vue&type=script&lang=js"
export * from "./SortableTableHeading.vue?vue&type=script&lang=js"

import "./SortableTableHeading.vue?vue&type=style&index=0&id=269987da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269987da"]])

export default __exports__